export default "__VITE_ASSET__Du5QbuUS__"